import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface RegistrationState {
  selectedPlan?: string;
  acceptTerms?: boolean;
  acceptPrivacy?: boolean;
}

export const createInitialRegistrationState = (): RegistrationState => ({
  selectedPlan: undefined,
  acceptTerms: undefined,
  acceptPrivacy: undefined,
});

const registrationSlice = createSlice({
  name: "registration",
  initialState: createInitialRegistrationState(),
  reducers: {
    selectPlan: (state, action: PayloadAction<string>) => {
      state.selectedPlan = action.payload;
      localStorage.setItem("registrationState", JSON.stringify(state));
    },
    updateTerms: (
      state,
      action: PayloadAction<{ acceptTerms: boolean; acceptPrivacy: boolean }>
    ) => {
      state.acceptTerms = action.payload.acceptTerms;
      state.acceptPrivacy = action.payload.acceptPrivacy;
      localStorage.setItem("registrationState", JSON.stringify(state));
    },
    clearRegistration: () => {
      localStorage.removeItem("registrationState");
      return createInitialRegistrationState();
    },
  },
});

export const { selectPlan, updateTerms, clearRegistration } =
  registrationSlice.actions;
export default registrationSlice.reducer;
